import mixpanelBrowser from "mixpanel-browser";
import getMixpanelApiHost from "./mixpanelConfig.cjs";

let isMixpanelInitialized = false;

if (!isMixpanelInitialized && !process.env.NEXT_PUBLIC_IS_E2E_TEST) {
	const apiHost =
		typeof window !== "undefined"
			? `${window.location.origin}/api/mixpanel`
			: getMixpanelApiHost(process.env.NEXT_PUBLIC_MIXPANEL_REGION);

	mixpanelBrowser.init(
		process.env.NEXT_PUBLIC_MIXPANEL_TOKEN,
		{
			batch_size: 1,
			batch_flush_interval_ms: 1,
			debug: process.env.NODE_ENV === "development",
			track_pageview: true,
			api_host: apiHost,
		},
		"felixMixpanel",
	);

	mixpanelBrowser.init(
		process.env.NEXT_PUBLIC_MIXPANEL_TOKEN,
		{
			api_host: apiHost,
			record_heatmap_data: true,
			autocapture: false,
			record_sessions_percent: 1,
			record_mask_text_selector:
				"input, [id*='react-select'], .address-select-input *",
			record_mask_text_class: /ReviewSection__Value.*$/,
			debug: process.env.NODE_ENV === "development",
		},
		"felixMixpanelRecorder",
	);

	// Expose Mixpanel on window for Optimizely integration
	// Optimizely requires window.mixpanel to send events and super properties
	if (typeof window !== "undefined") {
		window.mixpanel = mixpanelBrowser.felixMixpanel;
	}

	isMixpanelInitialized = true;
}

export const mixpanelTrackPageview = () => {
	mixpanelBrowser?.felixMixpanel?.track_pageview();
};
const replaceNullUndefinedWithEmptyString = (obj) => {
	if (typeof obj !== "object" || obj === null) {
		// If the input is not an object or is null, return it as is
		return obj;
	}

	if (Array.isArray(obj)) {
		return obj.map((value) => {
			const parsedValue = replaceNullUndefinedWithEmptyString(value);
			return parsedValue === null || typeof parsedValue === "undefined"
				? "undefined"
				: parsedValue;
		});
	}

	// Use Object.keys to get the object's property names
	const keys = Object.keys(obj);

	// Use Array.prototype.reduce to create a new object with replaced values
	const result = keys.reduce((acc, key) => {
		// Recursively call the function for nested objects
		acc[key] = replaceNullUndefinedWithEmptyString(obj[key]);

		// Replace null or undefined with an empty string
		if (acc[key] === null || typeof acc[key] === "undefined") {
			acc[key] = "undefined";
		}

		return acc;
	}, {});

	return result;
};

export const mixpanelTrack = async (trackName, payload) => {
	// mixpanel crashes if we try to send nullish values, so we filter them here
	const parsedPayload = replaceNullUndefinedWithEmptyString(payload);

	if (!trackName) {
		console.error("mixpanel track doesn't have a name");
		return;
	}

	try {
		await mixpanelBrowser?.felixMixpanel?.track(trackName, parsedPayload);
	} catch (error) {
		console.error("Error sending track event:", error);
	}
};

export const mixpanelAlias = (id) => {
	console.log(id);
	if (!id) {
		console.error("mixpanel alias doesn't have an id");
		return;
	}
	mixpanelBrowser?.felixMixpanel?.alias(id);
};

export const mixpanelIdentify = (id) => {
	console.log(id);
	if (!id) {
		console.error("mixpanel identify doesn't have an id");
		return;
	}
	mixpanelBrowser?.felixMixpanel?.identify(id);
};

export const mixpanelSetPeople = (id) => {
	if (!id) {
		console.error("mixpanel setPeople doesn't have an id");
		return;
	}
	mixpanelBrowser?.felixMixpanel?.people.set({ $awsID: id });
};

export const mixpanelSetUserProperties = (key, properties) => {
	if (!properties) {
		return;
	}
	if (typeof properties !== "object") {
		const propertiesObject = { [key]: properties };
		mixpanelBrowser.felixMixpanel?.people.set(propertiesObject);
		return;
	}
	const propertiesObject = { [`$${key}`]: properties };

	mixpanelBrowser?.felixMixpanel?.people.set(propertiesObject);
};

export const mixpanelRegisterSuperProperties = (properties) => {
	if (!properties) {
		console.error("mixpanel registerSuperProperties doesn't have properties");
		return;
	}

	mixpanelBrowser?.felixMixpanel?.register(properties);
};
